import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ad_zone = _resolveComponent("ad-zone")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.is), {
    class: _normalizeClass(["page", { 'page--has-banner': _ctx.hasBanner }])
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.hasBanner)
        ? (_openBlock(), _createBlock(_component_ad_zone, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class"]))
}